import React from 'react';
import { utcToLocalTime } from '../../../../../../utils/timeUtils';
import { formatTime } from '../../../../../../utils/types';

/**
 * Custom hook for calculating and displaying local time helpers
 */
export function useLocalTimeHelper() {
  /**
   * Calculate and display local time helper text
   */
  const getLocalTimeHelper = (
    utcTime: string,
    utcOffset: string,
    dayChange: number
  ): React.JSX.Element | null => {
    if (!utcTime || !utcOffset) return null;

    const result = utcToLocalTime(utcTime, utcOffset, dayChange);
    if (!result) return null;

    return (
      <div className="mt-1 text-xs text-gray-600 text-center">
        <span className="font-medium">Local Time:</span>{' '}
        <span className="font-mono font-semibold text-primary-600">
          {formatTime(result.localTime)}
        </span>
      </div>
    );
  };

  return { getLocalTimeHelper };
}